import React, { useEffect, useState } from "react";
import styled from "styled-components";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

// state - error, success

const Accordion = ({
  title,
  disabled,
  state,
  children,
  isInitiallyOpen = false,
  isOpen,
  setIsOpen,
  redBorder = false,
  id,
  canOpen = true,
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(isInitiallyOpen);

  useEffect(() => {
    setIsAccordionOpen(isInitiallyOpen);
  }, [isInitiallyOpen]);

  const toggle = () => {
    if (!canOpen) return;
    setIsOpen && setIsOpen(!isOpen);
    setIsAccordionOpen(!isAccordionOpen);
  };

  const open = (isOpen ?? isAccordionOpen) && canOpen;

  return (
    <AccordionContainer redBorder={redBorder} id={id || ""}>
      <AccordionHeader canOpen={canOpen} onClick={toggle} active={open}>
        <AccordionTitle disabled={disabled} state={state}>
          {state === "success" ? (
            <CheckCircleIcon
              style={{
                color: "#108145",
                fontSize: "24px",
              }}
            />
          ) : state === "error" ? (
            <CancelIcon
              style={{
                color: "#C54600",
                fontSize: "20px",
              }}
            />
          ) : null}
          <div>{title}</div>
        </AccordionTitle>
        {canOpen && (
          <KeyboardArrowUpIconStyled disabled={disabled} active={open}>
            <KeyboardArrowUpIcon />
          </KeyboardArrowUpIconStyled>
        )}
      </AccordionHeader>
      <AccordionContentWrapper className={open ? "active" : ""}>
        <AccordionContent className={open ? "active" : ""}>
          {children}
        </AccordionContent>
      </AccordionContentWrapper>
    </AccordionContainer>
  );
};

export default Accordion;

export const KeyboardArrowUpIconStyled = styled.div`
  transform: ${({ active }) => (active ? "rotate(0deg)" : "rotate(180deg)")};
  transition: all 200ms;
  height: max-content;
  display: grid;
  place-items: center;
  color: ${({ disabled }) => (disabled ? "#5E5E5E" : "#000000")};
`;

export const AccordionContainer = styled.div`
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  max-width: 100%;

  outline: ${({ redBorder }) => (redBorder ? "1px solid #C54600" : "none")};
`;

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  cursor: ${({ canOpen }) => (canOpen ? "pointer" : "not-allowed")};

  background: #ffffff;
  border-bottom: ${({ active }) => (active ? "1px solid #E8E8E8" : "none")};
`;

export const AccordionTitle = styled.h3`
  font-size: 16px !important;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ state, disabled }) =>
    state === "error"
      ? "#C54600"
      : state === "success"
      ? "#108145"
      : disabled
      ? "#727272"
      : "#000000"};
`;

export const AccordionContentWrapper = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: grid-template-rows 200ms;
  max-width: 100%;
  background: #ffffff;

  &.active {
    grid-template-rows: 1fr;
  }
`;

export const AccordionContent = styled.div`
  min-height: 0;
  visibility: hidden;
  transition: visibility 200ms;
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;

  &.active {
    visibility: visible;
  }
`;
